import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EnrollmentGroupService {

  constructor(private http: HttpClient) { }

  getGroupsByType(type: string, orgId: any) {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/erlgroupbytype/${orgId}/${type}`);
  }

  getGroupsByTypeAndSubject( orgId: any,semesterId:any,subjectId:any,type: string) {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/erlgroupbysubjectbytype/${orgId}/${semesterId}/${subjectId}/${type}`);
  }

  getAllGroups() {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/erlgroups`);
  }

  addGroup(username: string, orgid: any, egroupCode: string, egroupNameAr: string, egroupNameEn: string, egroupType: string, active: string) {
    return this.http.post<any>(
      `${environment.API_URL_ADM}/api/erlgroups/${username}`, { orgid, egroupCode, egroupNameAr, egroupNameEn, egroupType, active });
  }

  getYears() {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/acmyear`);
  }

  getYear(id: number) {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/acmyear/${id}`);
  }

  updateYear(id: number, orgid: any, username: any, yearDescAr: any, yearDescEn: any, yearAbrv: any, yearStart: any, yearEnd: any, daysNo: any) {
    return this.http.put<any>(
      `${environment.API_URL_ADM}/api/acmyear/${username}/${id}`, { id, orgid, yearDescAr, yearDescEn, yearAbrv, yearStart, yearEnd, daysNo });
  }

  addYear(orgid: any, id: number, username: any, yearDescAr: any, yearDescEn: any, yearAbrv: any, yearStart: any, yearEnd: any, daysNo: any) {
    return this.http.post<any>(
      `${environment.API_URL_ADM}/api/acmyear/${username}`, { id, orgid, yearDescAr, yearDescEn, yearAbrv, yearStart, yearEnd, daysNo });
  }

  getBatches() {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/acmgrade`);
  }

  getYearSemesters(year: number) {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/acmsemesterbyyear/${year}`);
  }

  getSemester(id: number) {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/acmsemester/${id}`);
  }

  updateSemester(id: number, username: string, orgid: number, yearid:any, semesterNameAr: any, semesterNameEn: any, startDate: any, endDate: any, daysNo: any, orderNo: any, activeFlag: any) {
    return this.http.put<any>(
      `${environment.API_URL}/api/acmsemester/${username}/${id}`, {
        id, orgid, yearid, semesterNameAr, semesterNameEn, startDate, endDate, daysNo, orderNo, activeFlag
      });
  }

  createSemester(id: number, username: string, orgid: number, yearid:any, semesterNameAr: any, semesterNameEn: any, startDate: any, endDate: any, daysNo: any, orderNo: any) {
    let activeFlag = "YES";
    return this.http.post<any>(
      `${environment.API_URL}/api/acmsemester/${username}`, {
        id, orgid, yearid, semesterNameAr, semesterNameEn, startDate, endDate, daysNo, orderNo, activeFlag
      });
  }

  getBatchSubjects(orgId: number, batchId: number) {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/erlgradesubjectsbygrade/${orgId}/${batchId}`);
  }

  getBatchSubjects2(orgid: number, batchId:number) {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/acmgradesubjects/${orgid}/${batchId}`);
  }

  getSemesterBatches(orgId: number, year: number, semester: number) {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/acmgradebysemester/${orgId}/${year}/${semester}`);
  }

  getErlStudentSubject(org: number, year: number, semester: number, batch: number, studentStatus: number, gender: string = '') {
    if (gender != '') {
      return this.http.get<any>(
        `${environment.API_URL_ADM}/api/erlstudentsubjectsbygradebygenderbystatus/${org}/${year}/${semester}/${batch}/${gender}/${studentStatus}`);
    } else {
      return this.http.get<any>(
        `${environment.API_URL_ADM}/api/erlstudentsubjectsbygradebystatus/${org}/${year}/${semester}/${batch}/${studentStatus}`);
    }
  }

  getErlStudentsByGradeGenderStatusAssign(org: number, year: number, semester: number, batch: number, studentStatus: number, gender: string = 'ALL', statusAssign: string = 'ALL') {

    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/erlstudentsbygradegenderstatusassign/${org}/${year}/${semester}/${batch}/${gender}/${studentStatus}/${statusAssign}`);
  }

  // getStudentSubjectsByStudId(studId: number) {
  //   return this.http.get<any>(
  //     `${environment.API_URL_ADM}/api/erlstudentsubjects`);
  // }

  updateStudentSubjects(username: string, org: number, year: number, semester: number, studId: number, subject: number, dataToUpdate: any) {
    return this.http.put<any>(
      `${environment.API_URL_ADM}/api/erlstudentsubjects/${username}/${org}/${year}/${semester}/${studId}/${subject}`, { ...dataToUpdate });
  }
  updateStudentTheorySubjects(username: string, org: number, year: number, semester: number, studId: number, subject: number, dataToUpdate: any) {
    return this.http.put<any>(
      `${environment.API_URL_ADM}/api/erlstudentsubjectstheo/${username}/${org}/${year}/${semester}/${studId}/${subject}`, { ...dataToUpdate });
  }
  updateStudentClincSubjects(username: string, org: number, year: number, semester: number, studId: number, subject: number, dataToUpdate: any) {
    return this.http.put<any>(
      `${environment.API_URL_ADM}/api/erlstudentsubjectsclnc/${username}/${org}/${year}/${semester}/${studId}/${subject}`, { ...dataToUpdate });
  }

  
  getstudentstatuses( orgid: any,semster: number,studentId:any) {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/getstudentstatuses/${orgid}/${semster}/${studentId}`);
  }

  updatestudentstatus( orgid: any,semster: number,studentId:any,sts:any,usr:any) {
    console.log('inside updatestudentstatus',orgid,semster,studentId,sts,usr);
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/updatestudentstatus/${orgid}/${semster}/${studentId}/${sts}/${usr}`);
  }

}
